import React, {Component} from 'react';
import RangeBar from "../../components/charts/atoms/RangeBar";
import DonutChart from "../charts/DonutChart";


class ActivityTableWidget extends Component {

    getTypeText = (type) => {
        switch (type) {
            case 'liked_post':
                return 'Liked post';
            case 'commented':
                return 'Commented on post';
            case 'added_to_profile':
                return 'Listed on profile';
            case 'followed':
                return 'Followed';
            default:
                return '';
        }
    };

    getTypeColor = (type) => {
        switch (type) {
            case 'liked_post':
                return 'text-blue-500 bg-blue-50';
            case 'commented':
                return 'text-orange-500 bg-orange-50';
            case 'added_to_profile':
                return 'text-purple-500 bg-purple-50';
            case 'followed':
                return 'text-yellow-500 bg-yellow-50';
            default:
                return 'text-gray-500 bg-gray-50';
        }
    };

    render() {

        return (
            <div className='bg-white rounded-lg shadow-lg p-6 flex flex-col gap-3'>
                <p className='text-gray-800 text-2xl font-bold'>
                    Social Activity
                </p>
                <div className='flex flex-col gap-3'>
                    <div className='flex flex-row flex-1 border-b border-gray-200 pb-2'>
                        <div className='flex-[1]'>
                            <p className='text-xs text-gray-500'>
                                Name
                            </p>
                        </div>
                        <div className='flex-[1]'>
                            <p className='text-xs text-gray-500'>
                                Date (UTC)
                            </p>
                        </div>
                        <div className='flex-[1]'>
                            <p className='text-xs text-gray-500'>
                                Type
                            </p>
                        </div>
                    </div>
                    <div className='flex flex-col gap-3'>
                        {this.props.data.map((item) => (
                            <div key={item.id} className='flex flex-row flex-1 pb-2 last:pb-0 border-b border-gray-100 last:border-0'>
                                <div className='flex-[1]'>
                                    <p className='text-sm font-semibold text-gray-800'>{item.name}</p>
                                </div>
                                <div className='flex-[1]'>
                                    <p className='text-sm font-semibold text-gray-500'>{item.date}</p>
                                </div>
                                <div className='flex-[1] flex flex-row justify-start'>
                                    <div className={`${this.getTypeColor(item.type)} px-2 py-0.5 rounded-full`}>
                                        <p className={`text-sm font-bold`}>
                                            {this.getTypeText(item.type)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        {this.props.data.length === 0 && (
                            <div className='flex flex-row flex-1 pb-2  mt-4 mb-4'>
                                <div className='flex-[1] text-center'>
                                    <p className='text-sm font-semibold text-gray-800'>No social activity yet</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default ActivityTableWidget;
